export default "__VITE_ASSET__DQLgNbM6__"